/* tslint:disable */
/* eslint-disable */
/* @relayHash cdc5043c23c09248e3dfdc3a5faad698 */

import { ConcreteRequest } from "relay-runtime";
export type authorizeTokenQueryVariables = {};
export type authorizeTokenQueryResponse = {
    readonly viewer: {
        readonly isUserTokenValid: boolean | null;
    };
};
export type authorizeTokenQuery = {
    readonly response: authorizeTokenQueryResponse;
    readonly variables: authorizeTokenQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isUserTokenValid",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "authorizeTokenQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "authorizeTokenQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "authorizeTokenQuery",
    "id": "ferrum/289.0.0-2020-11-03T20:56:25.991Z/authorizeTokenQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '8b60fc748be9b1da275f7e090fc551e5';
export default node;
